import {createStylesParams} from '@wix/tpa-settings';

type IStylesParams = {};

export default createStylesParams<IStylesParams>({});
